import { api } from "../../api/client";

export type RaceScopeLevel = "national" | "district" | "constituency" | "ward";

export interface Race {
  id: string;
  name: string;
  description: string;
  scopeLevel: RaceScopeLevel;
  order: number;
}

interface List<T> { items: T[]; }

export const RacesApi = {
  list: () => api<List<Race>>("/races"),
  create: (body: { name: string; description?: string; scopeLevel: RaceScopeLevel; order?: number }) =>
    api<Race>("/races", { method: "POST", body: JSON.stringify(body) }),
  update: (id: string, body: Partial<{ name: string; description: string; scopeLevel: RaceScopeLevel; order: number }>) =>
    api<Race>(`/races/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  remove: (id: string) => api<void>(`/races/${id}`, { method: "DELETE" }),
};
